import React from "react";
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import { formatDate } from "../../../../../../../../util/Helpers"
import { toAbsoluteUrl } from "../../../../../../../../../_metronic/_helpers";

const ViewSafeLockModal = ({ showViewSafeLockModal, details, onHide }) => {


    return (
        <Modal
            show={showViewSafeLockModal}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
        >

            <Modal.Header >
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <SVG
                            title=""
                            src={toAbsoluteUrl("/media/svg/icons/Shopping/Credit-card.svg")}
                        />
                    </span>
                    Safe Lock Details
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body
                className="px-10 py-2"
            >
                <div className="row">

                    <div className="col-lg py-4">
                        <h6 className=" px">Deposit</h6>
                        <span className="text-muted">{details?.currency} {details?.safelockDeposits[0].deposit}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Interest Earned</h6>
                        <span className="text-muted">{details?.currency} {details?.safelockDeposits[0].interestEarned}</span>
                    </div>

                    <div className="col-lg py-4">
                        <h6 className=" px">Tenure</h6>
                        <span className="text-muted">{details?.tenor} days</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Tenure Left Over</h6>
                        <span className="text-muted">{details?.tenorleftover} days</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Customer Name</h6>
                        <span className="text-muted">{details?.customerName}</span>
                    </div>


                </div>
                <div className="row">
                    <div className="col-lg py-5">
                        <h6 className=" px">Transaction Reference</h6>
                        <span className="text-muted">{details?.safelockDeposits[0].tranRef}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Email</h6>
                        <span className="text-muted">{details?.emailAddr}</span>
                    </div>


                    <div className="col-lg py-4">
                        <h6 className=" px">Status</h6>
                        <span className="text-muted">{details?.safelockDeposits[0].paymentStatus}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Name</h6>
                        <span className="text-muted">{details?.name}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Payment Source</h6>
                        <span className="text-muted">{details?.paymentSource}</span>
                    </div>


                </div>

                <div className="row">
                    <div className="col-lg py-4">
                        <h6 className=" px">User ID</h6>
                        <span className="text-muted">{details?.userId}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">PayBack Time</h6>
                        <span className="text-muted">{details?.safelockDeposits[0]?.payBackTime}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Rate</h6>
                        <span className="text-muted">{details?.rate}%</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Maturity Time</h6>
                        <span className="text-muted">{details?.safelockDeposits[0]?.maturityTime}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Can Withdraw</h6>
                        <span className="text-muted">{details?.safelockDeposits[0]?.canWithdraw?.toString()}</span>
                    </div>


                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6 className=" px">Created At</h6>
                        <span className="text-muted">{formatDate(details?.safelockDeposits[0].createdAt)}</span>
                    </div>

                    <div className="col-lg py-4">
                        <h6 className=" px">Reccuring</h6>
                        <span className="text-muted"><span>{details?.isRecurring?.toString()}</span>
                        </span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Maturity Date</h6>
                        <span className="text-muted">{formatDate(details?.safelockDeposits[0]?.maturityDate)}</span>
                    </div>



                    <div className="col-lg py-4">
                        <h6 className=" px">PayBack Date</h6>
                        <span className="text-muted">{formatDate(details?.safelockDeposits[0]?.payBackDate)}</span>
                    </div>

                </div>
                <div className="row">
                    

                    <div className="col-lg py-4">
                        <h6 className=" px">Liquidated</h6>
                        <span className="text-muted"><span>{details?.safelockDeposits[0]?.isLiquidated?.toString()}</span>
                        </span>
                    </div>
                    <div className="col-lg py-4">
                        <h6 className=" px">Withdrawal Initiated</h6>
                        <span className="text-muted"><span>{details?.safelockDeposits[0]?.withdrawalInitiated?.toString()}</span>
                        </span>
                    </div>
                   
                </div>



            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-primary btn-elevate px-5"
                >
                    Okay
                </button>
            </Modal.Footer>
        </Modal>

    );
}

export default ViewSafeLockModal;